// jQueryプラグイン
import 'jquery.easing';
/* ----------------------------------------------------------------------------------
ページ内リンクのアニメーション
---------------------------------------------------------------------------------- */
export function pageLinkAnimationFunc() {
    var scrTop, jsAnkerLogin, moveLogin, position, target, getHeadH;
    scrTop = $('#scrTop');
    scrTop.on('click', function () {
        $('body,html').animate({
            scrollTop: 0
        }, 1500, 'easeInOutQuint');
        return false;
    });
}
export function externalPageLinkFunc() {
    var urls, id, $target, pos, fixedHeaderHeight;
    urls = $(location).attr('href');
    if (urls.indexOf('?id=') != -1) {
        id = urls.split('?id=');
        $target = $('#' + id[id.length - 1]);
        pos = $target.offset().top;
        fixedHeaderHeight = $('#header').outerHeight();
        if ($target.length) {
            // ヘッダーとサブナビの高さを調整
            $('html, body').animate({
                scrollTop: pos - fixedHeaderHeight
            }, 1500, 'easeInOutQuint');
        }
    }
}